// src/modules/restaurant/pages/respayment/hooks/useCurrentTime.ts
import { useEffect, useState } from "react";

export const useCurrentTime = () => {
  const [time, setTime] = useState({
    hours: "",
    minutes: "",
    seconds: "",
    day: "",
    month: "",
    year: "",
  });

  const updateTime = () => {
    const currentDate = new Date();
    const year = String(currentDate.getFullYear());
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    setTime({ hours, minutes, seconds, day, month, year });
  };

  useEffect(() => {
    updateTime();
  }, []);

  return { time, updateTime };
};
